import { render, staticRenderFns } from "./InitiatorBadge.vue?vue&type=template&id=43d03925"
import script from "./InitiatorBadge.vue?vue&type=script&lang=js"
export * from "./InitiatorBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports